import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask4200To4299Service {

  constructor() { }
}
